import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Home, Gamepad2 } from 'lucide-react';
import gsap from 'gsap';

export default function NotFound() {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current) {
      gsap.fromTo(
        ref.current,
        { opacity: 0, y: 24 },
        { opacity: 1, y: 0, duration: 0.5, ease: 'power3.out' }
      );
    }
  }, []);

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4 py-28">
      <div ref={ref} className="text-center max-w-lg">
        <p className="text-[10px] font-cyber font-medium text-cyber-pink uppercase tracking-[0.3em] mb-3">
          Error 404
        </p>
        <h1 className="font-cyber font-semibold text-5xl sm:text-6xl text-white uppercase mb-4">
          Sector <span className="text-cyber-blue">Not Found</span>
        </h1>
        <p className="text-gray-400 text-sm mb-8 leading-relaxed">
          The page you requested does not exist or was moved. Return to the store hub to continue browsing games.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-cyber-blue/20 border border-cyber-blue/40 text-cyber-blue text-xs font-cyber uppercase tracking-widest hover:bg-cyber-blue/30 transition-colors"
          >
            <Home className="w-4 h-4" />
            Home
          </Link>
          <Link
            to="/all-games"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-white/5 border border-white/10 text-gray-300 text-xs font-cyber uppercase tracking-widest hover:border-cyber-purple/40 transition-colors"
          >
            <Gamepad2 className="w-4 h-4" />
            Browse Games
          </Link>
        </div>
      </div>
    </div>
  );
}
